import SceneButton from '../components/SceneButton';

export default class PopUpController {
	constructor(scene, guiController) {
		this.scene = scene;
		this.guiController = guiController;
		this.createEvent = null;
		this.buttons = [];
	}

	_show(createEventHandler) {
		this.wCont = this.scene.add.container(this.scene.centerX, this.scene.centerY);
		this.createEvent = createEventHandler;
		if (this.createEvent !== null) this.createEvent(this);
	}

	setControlsInteractable(interactable) {
		this.buttons.forEach(b => {
			if (b !== null) b.setInteractable(interactable);
		});
	}

	addButton(buttonName, spriteNormal, spriteHover, isSwitch, lPosX, lPosY) {
		this[buttonName] = new SceneButton(this.scene, spriteNormal, spriteHover, isSwitch);
		this[buttonName].create(0, 0, 0.5, 0.5);
		this.wCont.add(this[buttonName].button);
		this[buttonName].button.setPosition(lPosX, lPosY);
		this.buttons.push(this[buttonName]);
	}

	add(
		guiObject // guiObject: sprite, text, container
	) {
		this.wCont.add(guiObject);
	}
}
